import React from 'react';
import Grid from '@mui/material/Grid2';
import { Link, Tooltip } from '@mui/material';
import {
    Box,
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { filesExtToContentTypes } from '../../../utils/common';
const Questionnaire = (props) => {

    const {policyData} = props;

    const [questionnaire, setQuestionnaire] = React.useState([]);

    React.useEffect(() => {

        if (policyData?.pa_forms) {
            setQuestionnaire(policyData?.pa_forms);
        }

    }, [policyData]);

    const previewFile = (event, fileSrc, fileName="", isDownload=false) => {
        event.preventDefault()
        if (fileSrc) {
            console.log('fileSrc', fileSrc)
            props.setOpenLoader(true);

            let fileContentType = filesExtToContentTypes(fileName);

            (async () => {
                const res = await fetch(fileSrc.url)
                const fileData = await res.arrayBuffer()          
                let previewFileURL = URL.createObjectURL(new Blob([fileData], {
                    type: fileContentType
            })) ;
            
            props.setOpenLoader(false)

            if (isDownload) {
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                a.href = previewFileURL;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(previewFileURL);
            }
            else {
                window.open(previewFileURL);
            }
            })()
              
        }
    };

    return (
        <Box>
            {questionnaire && questionnaire.length>0 && (<>{/*<h2 className="sectionHeading">Questionnaires</h2>*/}
            <div className="preview-header-section" style={{marginTop: '20px'}} >
                { questionnaire.length===0 ? <p>No Data</p> : 
                (<ul style={{ listStyle: 'disc', "marginLeft": "15px", "paddingLeft": "0", marginTop: '0', marginBottom: '0' }}>
                    {
                        questionnaire.map( (a, index) => {
                            
                            return (
                                <li key={index} style={{"paddingBottom":"3px", "marginLeft": "0", "paddingLeft": "0"}}>
                                    <Grid container spacing={2}>
                                        <Grid item >
                                            <Link 
                                                onClick={(event) => {
                                                    previewFile(event, a.url, a.title);
                                                }}
                                                style={{"cursor":"pointer"}}
                                            >
                                                {`${a.title}`} 
                                            </Link>
                                        </Grid>
                                        <Grid item >
                                            <Tooltip title="Download File">
                                                <Link 
                                                    onClick={(event) => {
                                                        previewFile(event, a.url, a.title, true);
                                                    }}
                                                    style={{"cursor":"pointer"}}
                                                >
                                                    <FileDownloadIcon />
                                                </Link>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </li>
                            )

                        })
                    }
                </ul>)
                }
            </div></>)}
        </Box>
    )

}

export default Questionnaire;